<script>
/** Type mighty be : default (or null), highlight, overlay**/
export default {
    translate25Context: "transcript",
    props: ["component", "handler"],
    methods: {
    },
};
</script>

<template>
    <div class="transcript-export-vtt" >
        <f-button type="tertiary" :href="component.url"><f-icon icon="fa6-download"></f-icon>{{ $vt('Download') }}</f-button>

    </div>
</template>

<style lang="scss">
    .transcript-export-vtt {
        a {
            text-decoration: none;
            color: var(--white-a75);
        }
    }
</style>